/**
 * ХОД 2 — прогрев камеры для CV-проб NIHSS (ArticulationGame, cv_face_action).
 * Камера включается заранее, пока пациент отвечает на предыдущий вопрос шкалы.
 * Рукопожатие с сервером по-прежнему строго ПОСЛЕ камеры — порядок СТО сохранён.
 */

const WARM_MAX_AGE_MS = 120_000; // пациент может думать над пунктом 3 — держим запас

const DEFAULT_CONSTRAINTS = {
  audio: { sampleRate: 16000, sampleSize: 16, channelCount: 1 },
  video: {
    width: { min: 480, max: 640 },
    height: { min: 480, max: 640 },
    frameRate: { min: 15, max: 30 },
    facingMode: "user",
  },
};

let warmStream = null;
let warmPromise = null;
let warmedAt = 0;
let generation = 0; // защита от гонки «отменили прогрев, пока камера инициализировалась»

export function isPrewarmHot() {
  return warmStream != null && Date.now() - warmedAt <= WARM_MAX_AGE_MS;
}

/**
 * Запустить фоновый прогрев. Идемпотентна: повторный вызов не открывает вторую камеру.
 * Никогда не бросает ошибку наружу: шкале всё равно, проба стартует холодной как раньше.
 */
export function prewarmCamera(constraints = DEFAULT_CONSTRAINTS) {
  if (isPrewarmHot() && warmStream) return Promise.resolve(warmStream);
  if (warmPromise) return warmPromise; // уже греемся

  const startedAt = performance.now();
  const myGen = generation;

  const promise = navigator.mediaDevices
    .getUserMedia(constraints)
    .then((stream) => {
      if (myGen !== generation) {
        // прогрев успели отменить, пока камера инициализировалась — гасим треки
        stream.getTracks().forEach((t) => t.stop());
        return null;
      }
      warmStream = stream;
      warmedAt = Date.now();
      console.log(`[AG] PREWARM camera ready in ${(performance.now() - startedAt).toFixed(0)}ms`);
      return stream;
    })
    .catch((err) => {
      if (myGen === generation) {
        warmPromise = null; // разрешаем повторную попытку
        console.warn("[AG] PREWARM failed:", err instanceof DOMException ? err.name : String(err));
      }
      return null;
    });

  warmPromise = promise;
  return promise;
}

/**
 * Забрать прогретый поток для пробы. null → старт холодный, как сейчас.
 * После вызова поток считается переданным: взять его второй раз нельзя.
 */
export function takeWarmStream() {
  if (isPrewarmHot() && warmStream) {
    const stream = warmStream;
    warmStream = null;
    warmPromise = null;
    console.log("[AG] PREWARM consumed: hot start");
    return stream;
  }
  releaseWarmCamera(); // протух или не состоялся — чистим
  return null;
}

/** Погасить прогрев: ушла шкала, сбой, поток не пригодился. Безопасно вызывать всегда. */
export function releaseWarmCamera() {
  generation += 1;
  if (warmStream) warmStream.getTracks().forEach((t) => t.stop());
  warmStream = null;
  warmPromise = null;
  warmedAt = 0;
}